import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Table,Pagination, Button, message,Modal,Form,Input, Upload} from 'antd';
import * as actionCreators from '../service/ClientLinkCreator'
import '../App.css'
import intl from 'react-intl-universal';
import xlsx from 'xlsx'
import AddChannelModal from './AddChModal';

const confirm = Modal.confirm;
const FormItem = Form.Item;
const EditableContext = React.createContext();
const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
      <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
    state = {
        editing: false,
    }
    componentDidMount() {
      if (this.props.editable) {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }
    componentWillUnmount() {
      if (this.props.editable) {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }
    toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
        if (editing) {
          this.input.focus();
        }
      });
    }
    handleClickOutside = (e) => {
      const { editing } = this.state;
      if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
        this.save();
      }
    }
    save = () => {
      const { record, handleSave } = this.props;
      this.form.validateFields((error, values) => {
        if (error) {
          return;
        }
        this.toggleEdit();
        handleSave({ ...record, ...values });
      });
    }
    render() {
        const { editing } = this.state;
        const {
          editable,
          dataIndex,
          title,
          record,
          index,
          handleSave,
          ...restProps
        } = this.props;
        return (
          <td ref={node => (this.cell = node)} {...restProps}>
            {editable ? (
              <EditableContext.Consumer>
                {(form) => {
                  this.form = form;
                  return (
                    editing ? (
                      <FormItem style={{ margin: 0 }}>
                        {form.getFieldDecorator(dataIndex, {
                          rules: [{
                            required: true,
                            message: `${title} is required.`,
                          }],
                          initialValue: record[dataIndex],
                        })(
                          <Input
                            ref={node => (this.input = node)}
                            onPressEnter={this.save}
                          />
                        )}
                      </FormItem>
                    ) : (
                      <div
                        className="editable-cell-value-wrap"
                        style={{ paddingRight: 24 }}
                        onClick={this.toggleEdit}
                      >
                        {restProps.children}
                      </div>
                    )
                  );
                }}
              </EditableContext.Consumer>
            ) : restProps.children}
          </td>
        );
    }
}

class ChannelList extends Component {
    constructor(){
        super()
        this.state={
            columns:[
                {
                    title: intl.get("sequence"),
                    dataIndex: 'sequence',
                    // key: 'sequence',
                    // width:'10%'
                    render: (text, record, index) => (
                      <span>{(this.props.currentPage > 1 ? (this.props.currentPage - 1) : 0) * this.props.pageSize + index + 1}</span>
                  )
                },
                {
                  title: intl.get("showNo"),
                  dataIndex: "showNo",
                  key: "showNo",
                  width:'15%',
                  editable: true
                },
                {
                title: intl.get("name"),
                dataIndex: "name",
                key: "name",
                width:'20%',
                editable: true
                },
                {
                    title: intl.get("url"),
                    dataIndex: "url",
                    key: "url",
                    width:'55%',
                    editable: true
                }
            ],
            initColumn:[{
              title: 'name',
              dataIndex: 'name',
              key: 'name',
              className: 'excel_text'
            }, {
              title: 'url',
              dataIndex: 'url',
              key: 'url',
              className: 'excel_text'
            }, {
              title: 'category',
              dataIndex: 'categoryName',
              key: 'categoryName',
              className: 'excel_text'
            },{
              title: 'cause',
              dataIndex: 'msg',
              key: 'msg'
            }],
            selectedRowKeys:[],
            warningText : ""
        }

        this.changePage = this.changePage.bind(this)
        this.onShowSizeChange = this.onShowSizeChange.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.uploadExcel = this.uploadExcel.bind(this)
        this.showAddModal = this.showAddModal.bind(this)
        this.onSelectedRowKeysChange = this.onSelectedRowKeysChange.bind(this)
        this.batchDelete = this.batchDelete.bind(this)
        this.updateSelectedKeys = this.updateSelectedKeys.bind(this)
    }

    handExport = (categoryid) => {
        confirm({
            title: intl.get("confirmExport"),
            onOk() {
                var page_url = "/api/exportChannels?categoryid=" + categoryid + "&user=" + sessionStorage.getItem("userName")
                var req = new XMLHttpRequest();
                req.open("POST", page_url, true);
                //监听进度事件
                req.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        message.success("Download successful")
                    }
                }, false);
                req.responseType = "blob";
                req.onreadystatechange = function () {
                    if (req.readyState === 4 && req.status === 200) {
                       /*  var filename = that.data('filename'); */
                       var name = req.getResponseHeader("Content-disposition");
                        if (typeof window.chrome !== 'undefined') {
                            // Chrome version
                            var link = document.createElement('a');
                            link.href = window.URL.createObjectURL(req.response);
                            link.download = name;
                            link.click();
                        } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE version
                            var blob = new Blob([req.response], { type: 'application/force-download' });
                            window.navigator.msSaveBlob(blob, name);
                        } else {
                            // Firefox version
                            var file = new File([req.response], name, { type: 'application/force-download' });
                            window.open(URL.createObjectURL(file));
                        }
                    }
                };
                req.send();
            }
        })
    }

    handExportModal(){
      confirm({
        title: intl.get("confirmExport"),
        onOk() {
            var page_url = '/api/exportChannelsModal';
            var req = new XMLHttpRequest();
            req.open("POST", page_url, true);
            //监听进度事件
            req.addEventListener("progress", function (evt) {
                if (evt.lengthComputable) {
                    message.success("Download successful")
                }
            }, false);
            req.responseType = "blob";
            req.onreadystatechange = function () {
                if (req.readyState === 4 && req.status === 200) {
                   /*  var filename = that.data('filename'); */
                   var name = req.getResponseHeader("Content-disposition");
                    if (typeof window.chrome !== 'undefined') {
                        // Chrome version
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(req.response);
                        link.download = name;
                        link.click();
                    } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        // IE version
                        var blob = new Blob([req.response], { type: 'application/force-download' });
                        window.navigator.msSaveBlob(blob, name);
                    } else {
                        // Firefox version
                        var file = new File([req.response], name, { type: 'application/force-download' });
                        window.open(URL.createObjectURL(file));
                    }
                }
            };
            req.send();
        }
      })
    }

    handleSave = (row) => {
      //channelname长度限制
      if(row.name.length>40){
        message.warning("channel name is at most 40 characters")
      }else{
        this.props.updateChannel(row,this.props.categoryid,this.props.currentPage,this.props.pageSize,sessionStorage.getItem("userName"));
      }
    }

    changePage(page){
      this.props.changePage(page,this.props.pageSize,this.props.categoryid,sessionStorage.getItem("userName"))
    }
    onShowSizeChange(current,pageSize){
      this.props.onShowSizeChange(1,pageSize,this.props.categoryid,sessionStorage.getItem("userName"))
    }

    componentWillMount(){
      this.props.getChannelListByPage(this.props.currentPage,this.props.pageSize,this.props.categoryid,sessionStorage.getItem("userName"))
    }

    showAddModal(){
      this.props.showChannleModal()
    }

    batchDelete=()=>{
      var that = this
      if(this.props.selectedRows.length<1){
        message.error(intl.get("atLeaseSelectOne"))
      }else{
        confirm({
            title: "Do you confirm to delete the item",
            onOk(){
              that.props.batchDelete(that.props.selectedRows,that.props.pageSize,sessionStorage.getItem("userName"),that.updateSelectedKeys,that.props.selectKey)
          }
        });
      }
    }

    onSelectedRowKeysChange(selectedRowKeys,selectedRows){
      this.setState({selectedRowKeys})
      this.props.updateSelectedData(selectedRows)
    }

    updateSelectedKeys(rows){
      let selectKeys = this.state.selectedRowKeys;
      for(let i=0;i<rows.length;i++){
          selectKeys.splice(selectKeys.indexOf(rows.sequence),1)
      }
      this.setState({
          selectedRowKeys:selectKeys
      })
    }

    uploadExcel(){
        var _this = this
        let file = document.getElementById("channelFile").files[0]
        var fileReader = new FileReader();
        fileReader.onload = function(ev) {
            try {
                var data = ev.target.result,
                    workbook = xlsx.read(data, {type: 'binary'}),
                    channels = []; // 存储获取到的数据
            } catch (e) {
                return;
            }
            // 表格的范围，可用于判断表头数量是否正确
            let fromTo = '';
            // 遍历每张表读取
            let flag = true
            for (var sheet in workbook.Sheets) {
                if (workbook.Sheets.hasOwnProperty(sheet)) {
                    fromTo = workbook.Sheets[sheet]['!ref'];
                    channels = channels.concat(xlsx.utils.sheet_to_json(workbook.Sheets[sheet]));
                    let title_1,title_2,title_3
                    if(typeof(workbook.Sheets[sheet].A1)==="undefined"){
                      title_1 = false
                    }else{
                      title_1 = workbook.Sheets[sheet].A1.v ? true : false
                    }

                    if(typeof(workbook.Sheets[sheet].B1)==="undefined"){
                      title_2 = false
                    }else{
                      title_2 = workbook.Sheets[sheet].B1.v ? true : false
                    }

                    if(typeof(workbook.Sheets[sheet].C1)==="undefined"){
                      title_3 = false
                    }else{
                      title_3 = workbook.Sheets[sheet].C1.v ? true : false
                    }
                    flag = (title_1&&title_2&&title_3)
                    break; // 如果只取第一张表，就取消注释这行
                }
            }
            if(flag===true){
              _this.props.uploadExcel(channels,_this.props.categoryid,_this.props.currentPage,_this.props.pageSize,sessionStorage.getItem("userName"),_this.state.initColumn,_this.showWrongListMessage)
            }else{
              message.error("please import by template")
            }
            _this.refs.pathClear.value = '';
          }
        // 以二进制方式打开文件
        if(file!==null&&typeof(file)!=="undefined"){
          fileReader.readAsBinaryString(file);
        }
      // }
    }

    showWrongListMessage = (total,successImport,failImport,duplicateChannelName,overLongChannelName,overLongCategoryName,urlFormatError) =>{
      let numArr = [successImport,failImport,duplicateChannelName,overLongChannelName,overLongCategoryName,urlFormatError]
      let desArr = ["Successful import: ","Failed import: ","Duplicate channel name: ","Over-long channel name: ","Over-long category name: ","Url format error: "]
      message.warning(<div dangerouslySetInnerHTML={{__html: this.showNotZeroItem(total,numArr,desArr)}}></div>,8)
    }

    showNotZeroItem = (total,numArr,desArr) =>{
      let returnText = '<p>Total: ' + total + ' Channels</p>';
      for(let i =0;i<numArr.length;i++){
        if(numArr[i]!==0){
          returnText+= '<p>' + desArr[i] + numArr[i] + '</p>'
        }
      }
      return returnText
    }
    
    render() {
        const components = {
          body: {
            row: EditableFormRow,
            cell: EditableCell,
          },
        };

        const columns = this.state.columns.map((col) => {
          if (!col.editable) {
            return col;
          }
          return {
            ...col,
            onCell: record => ({
              record,
              editable: col.editable,
              dataIndex: col.dataIndex,
              title: col.title,
              handleSave: this.handleSave,
            }),
          };
        });

        let that = this
        let categoryid = this.props.selectKey
        const fileprops = {
          name: 'file',
          action: '/api/parseFile?username='+sessionStorage.getItem("userName")+"&categoryId="+this.props.selectKey,
          headers: {
              authorization: 'authorization-text',
          },
          onChange(info) {
              if (info.file.status === 'done') {
                  var response = info.file.response
                  if(response.returnCode === -1){
                    message.warning(`${info.file.name}` + intl.get('common.upload.file.exceptions'))
                  }else if(response.returnCode === 0){
                    message.success(`${info.file.name}` + intl.get('common.upload.file.success'))
                    that.props.updateCategoryNum();
                    if(categoryid === ""){
                      categoryid = 0
                    }
                    that.props.getChannelListByPage(that.props.currentPage,that.props.pageSize,categoryid,sessionStorage.getItem("userName"))
                    that.props.updataSelectKey(that.props.selectKey)
                  }else if(response.returnCode === 1){
                    message.warning(`${info.file.name}` + intl.get('wrong.file.format'))
                  }else if(response.returnCode === 2){
                    message.warning(intl.get('too.many.classifications.or.programs'))
                  }
              }
          },
      };


        const { selectedRowKeys } = this.state;
        const rowSelection = {
          selectedRowKeys,
          // onChange: (selectedRowKeys, selectedRows) => {
          //     this.setState({selectedRowKeys})
          //     this.props.updateSelectedData(selectedRows);
            
          // },
          onChange: this.onSelectedRowKeysChange
        };

        return (
            <div>
                <div className="button-style">
                    <Button icon="upload" type="primary">
                      {intl.get("import")}
                      <input type="file" className="fileInput" onChange={()=>this.uploadExcel()} id="channelFile" ref='pathClear'
                      accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
                    </Button>
                </div>
                
                {/* import m3u8 File */}
                <div className="button-style">
                    <Upload {...fileprops}>
                            <Button type="primary" icon="upload" className="tool">{intl.get("import.m3u8.file")}</Button>
                        </Upload>
                </div>

                <div className="button-style">
                    <Button icon="export" onClick={()=>this.handExport(this.props.categoryid)} type="primary">{intl.get("export")}</Button> 
                    <iframe id="ifile" className="exportFile" title="exportExcel"></iframe>
                </div>
                <div className="button-style">
                    <Button icon="export" onClick={()=>this.handExportModal()} type="primary">{intl.get("exportModal")}</Button> 
                    <iframe id="ifile" className="exportFile" title="exportTemplate"></iframe>
                </div>
                <div className="button-style">
                    <Button icon="plus" onClick={this.showAddModal} type="primary">
                      {intl.get("add")}
                    </Button>
                </div>
                <div className="button-style">
                    <Button icon="minus" onClick={this.batchDelete} type="primary">
                      {intl.get("delete")}
                    </Button>
                </div>
                <div className="clear"></div>
                <Table columns={columns} dataSource={this.props.channelList} rowKey={row => row.id} 
                               pagination={false} loading={this.props.shadeVisible} bordered components={components}
                               rowClassName={()=>'editable-row'}
                               rowSelection={rowSelection}
                               loading={this.props.shadeVisible}
                                />
                <Pagination  total={this.props.total} onChange={this.changePage} 
                               style={{marginTop:"20px",float:"right"}}
                               onShowSizeChange={this.onShowSizeChange}
                               showSizeChanger={true}
                               pageSize={this.props.pageSize}
                               pageSizeOptions={["10","15","20","30","40"]}
                               current={this.props.currentPage}
                               showTotal={
                                   (total, range) => {
                                       if(total===0){
                                         return intl.get("from") + 0 + intl.get("to") + 0 + intl.get("of") + 0 + intl.get("items")
                                       }
                                       return intl.get("from") + ` ${range[0]} ` + intl.get("to") + ` ${range[1]}` + intl.get("of") + `${total}` + intl.get("items")
                                   }
                               }
                />
                <AddChannelModal/>
            </div>
    );
  }
}

const mapState = (state) => {
  return {
      currentPage:state.clientLink.currentPage,
      pageSize:state.clientLink.pageSize,
      categoryid:state.clientLink.categoryid,
      channelList:state.clientLink.channelList,
      total:state.clientLink.total,
      selectedRows : state.clientLink.selectedRows,
      shadeVisible : state.clientLink.shadeVisible,
      categoryList : state.clientLink.categoryList,
      selectKey : state.clientLink.selectKey
  }
}

const mapDispatch = (dispatch) => {
  return {
    changePage(currentPage,pagesize,categoryid,userName){
        dispatch(actionCreators.updateCurrentPage(currentPage))
        dispatch(actionCreators.getChannelListByPage(currentPage,pagesize,categoryid,userName))
    },

    onShowSizeChange(currentPage,pagesize,categoryid,userName){
        dispatch(actionCreators.updatePageSize(pagesize))
        dispatch(actionCreators.updateCurrentPage(currentPage))
        dispatch(actionCreators.getChannelListByPage(currentPage,pagesize,categoryid,userName))
    },

    getChannelListByPage(currentPage,pagesize,categoryid,userName){
        dispatch(actionCreators.getChannelListByPage(currentPage,pagesize,categoryid,userName))
    },

    updateChannel(row,categoryid,currentPage,pageSize,userName){
      dispatch(actionCreators.updateChannel(row,categoryid,currentPage,pageSize,userName))
    },

    uploadExcel(channels,categoryid,currentPage,pageSize,userName,initColumn,callback){
      dispatch(actionCreators.uploadExcel(channels,categoryid,currentPage,pageSize,userName,initColumn,callback))
    },

    showChannleModal(){
      dispatch(actionCreators.showChannleModal())
    },

    updateSelectedData(rows){
      dispatch(actionCreators.updateSelectedData(rows))
    },

    batchDelete(rows,pageSize,user,updateSelectedKeys,cid){
      dispatch(actionCreators.batchDeleteChannels(rows,pageSize,user,cid))
      updateSelectedKeys(rows)
    },

    updateCategoryNum(){
      dispatch(actionCreators.initCategoryList(sessionStorage.getItem("userName"), null))
    },
    updataSelectKey(selectkey){
      dispatch(actionCreators.updataSelectKey(selectkey))
    }
  }
}

export default connect(mapState, mapDispatch)(ChannelList);


// WEBPACK FOOTER //
// ./src/components/ChannelList.js